"use strict";
var core_1 = require('angular2/core');
var dispatcher_1 = require('./dispatcher');
var store_1 = require('./store');
var store_backend_1 = require('./store-backend');
var utils_1 = require('./utils');
exports.PRE_MIDDLEWARE = new core_1.OpaqueToken('ngrx/store/pre-middleware');
exports.POST_MIDDLEWARE = new core_1.OpaqueToken('ngrx/store/post-middleware');
exports.RESOLVED_PRE_MIDDLEWARE = new core_1.OpaqueToken('ngrx/store/resolved-pre-middleware');
exports.RESOLVED_POST_MIDDLEWARE = new core_1.OpaqueToken('ngrx/store/resolved-post-middleware');
exports.REDUCER = new core_1.OpaqueToken('ngrx/store/reducer');
exports.INITIAL_STATE = new core_1.OpaqueToken('ngrx/store/initial-state');
var dispatcherProvider = core_1.provide(dispatcher_1.Dispatcher, {
    useFactory: function () {
        return new dispatcher_1.Dispatcher();
    }
});
var storeProvider = core_1.provide(store_1.Store, {
    deps: [dispatcher_1.Dispatcher, store_backend_1.StoreBackend, exports.INITIAL_STATE],
    useFactory: function (dispatcher, backend, initialState) {
        return new store_1.Store(dispatcher, backend, initialState);
    }
});
var storeBackendProvider = core_1.provide(store_backend_1.StoreBackend, {
    deps: [dispatcher_1.Dispatcher, exports.REDUCER, exports.INITIAL_STATE, exports.RESOLVED_PRE_MIDDLEWARE, exports.RESOLVED_POST_MIDDLEWARE],
    useFactory: function (dispatcher, reducer, initialState, preMiddleware, postMiddleware) {
        return new store_backend_1.StoreBackend(dispatcher, reducer, initialState, preMiddleware, postMiddleware);
    }
});
var resolvedPreMiddlewareProvider = core_1.provide(exports.RESOLVED_PRE_MIDDLEWARE, {
    deps: [exports.PRE_MIDDLEWARE],
    useFactory: function (middleware) {
        return utils_1.compose.apply(void 0, middleware);
    }
});
var resolvedPostMiddlewareProvider = core_1.provide(exports.RESOLVED_POST_MIDDLEWARE, {
    deps: [exports.POST_MIDDLEWARE],
    useFactory: function (middleware) {
        return utils_1.compose.apply(void 0, middleware);
    }
});
function provideStore(reducer, initialState) {
    return [
        core_1.provide(exports.REDUCER, {
            useFactory: function () {
                if (typeof reducer === 'function') {
                    return reducer;
                }
                return utils_1.combineReducers(reducer);
            }
        }),
        core_1.provide(exports.INITIAL_STATE, {
            deps: [exports.REDUCER],
            useFactory: function (reducer) {
                if (initialState === undefined) {
                    return reducer(undefined, { type: store_backend_1.ActionTypes.INIT });
                }
                return initialState;
            }
        }),
        core_1.provide(exports.PRE_MIDDLEWARE, { multi: true, useValue: (function (T) { return T; }) }),
        core_1.provide(exports.POST_MIDDLEWARE, { multi: true, useValue: (function (T) { return T; }) }),
        dispatcherProvider,
        storeProvider,
        storeBackendProvider,
        resolvedPreMiddlewareProvider,
        resolvedPostMiddlewareProvider
    ];
}
exports.provideStore = provideStore;
function usePreMiddleware() {
    var middleware = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        middleware[_i - 0] = arguments[_i];
    }
    return provideMiddlewareForToken(exports.PRE_MIDDLEWARE, middleware);
}
exports.usePreMiddleware = usePreMiddleware;
function usePostMiddleware() {
    var middleware = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        middleware[_i - 0] = arguments[_i];
    }
    return provideMiddlewareForToken(exports.POST_MIDDLEWARE, middleware);
}
exports.usePostMiddleware = usePostMiddleware;
function createMiddleware(useFactory, deps) {
    return core_1.provide(new core_1.OpaqueToken('@ngrx/store middleware'), {
        deps: deps,
        useFactory: useFactory
    });
}
exports.createMiddleware = createMiddleware;
function provideMiddlewareForToken(token, _middleware) {
    function isProvider(t) {
        return t instanceof core_1.Provider;
    }
    var provider = core_1.provide(token, {
        multi: true,
        deps: [core_1.Injector],
        useFactory: function (injector) {
            var middleware = _middleware.map(function (m) {
                if (isProvider(m)) {
                    return injector.get(m.token);
                }
                return m;
            });
            return utils_1.compose.apply(void 0, middleware);
        }
    });
    return _middleware.filter(isProvider).concat([provider]);
}
exports.provideMiddlewareForToken = provideMiddlewareForToken;



/*****************
 ** WEBPACK FOOTER
 ** ./~/@ngrx/store/dist/ng2.js
 ** module id = 240
 ** module chunks = 0
 **/